PM_SCREEN_TYPE_EVENTS_PLUS